import { ServiceHelper } from "components/helpers/index";

class QueueTimesService {
  getQueueTimes() {
    return ServiceHelper.fetchGet("/QueueTimes/");
  }
}

const helper = new QueueTimesService();
export default helper;
